import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';
import { queryOrder } from 'src/api/';

interface Prop {}
interface State {
    orders: Array<any>;
    queryKey: string;
}

@injectIntl()
export default class SearchResult extends Base<Prop, State> {
    constructor(props: any) {
        super(props);
        this.state = { orders: [], queryKey: '' };
    }
    loadOrder = async () => {
        const { match, history } = this.props;
        const { queryKey } = this.state;
        const commodity = JSON.parse(sessionStorage.getItem('commodity') as string);
        const commodityId = commodity.id;
        if (!commodityId || !queryKey) {
            history?.goBack();
            return;
        }
        const { data } = await queryOrder({ commodityId, orderCodeOrPhone: queryKey.replace('#', '') });
        this.setState({ orders: data });
        this.props.history?.replace({
            pathname: `/cod/order-confirm`,
            state: { orders: data },
        });
    };

    queryOrderHandler = () => {
        if (!this.state.queryKey?.trim()) {
            return;
        }
        this.loadOrder();
    };

    backHomeHandler = () => {
        this.props.history?.goBack();
    };

    getLastString = (str: string, len: number) => {
        const newStr = str?.substring(str?.length - len);
        return newStr ?? '';
    };
    render() {
        const { orders } = this.state;
        const { intl } = this.props;
        return (
            <>
                <div className="content">
                    <div className="header">
                        <a className="goback" href="/">
                            <FormattedMessage id="go-back" />
                        </a>
                    </div>
                    <h2 className="title">
                        <FormattedMessage id="query-order" />
                    </h2>
                    {/* <div className="prompt">
                        <FormattedMessage id="search-order.input_order_code" />
                    </div> */}
                    <div className="from flexbox">
                        <input
                            className="inquiry_mob flex"
                            type="text"
                            name="mob"
                            placeholder={intl?.formatMessage({ id: 'input-phone-or-order-number' })}
                            onChange={(e: any) => {
                                this.setState({ queryKey: e.target.value?.trim() });
                            }}
                        />
                        <button id="go" onClick={this.queryOrderHandler}></button>
                    </div>
                    <div id="inquiry_list"></div>
                    {/* <div className="prevpage" style={{ display: 'none' }}>
                        <FormattedMessage id="search-order.pre_page" />
                    </div>
                    <div className="nextpage" style={{ display: 'none' }}>
                        <FormattedMessage id="search-order.next_page" />
                    </div> */}
                </div>
            </>
        );
    }
}
